import { useAuth } from "@/hooks/useAuth";
import { canMountSymphonyWidget, readSymphonyRuntimeConfig } from "@/symphony/flag";

export function useSymphonyWidgetEnabled(): boolean {
  const { user } = useAuth();
  const config = readSymphonyRuntimeConfig();
  return canMountSymphonyWidget({
    envEnabled: config.enabled ? "true" : undefined,
    allowedUserIds: config.allowedUserIds,
    publishableKey: config.publishableKey,
    loaderUrl: config.loaderUrl,
    gateway: config.gateway,
    userId: user?.id,
    appMetadata: (user?.app_metadata ?? null) as Record<string, unknown> | null,
    userMetadata: (user?.user_metadata ?? null) as Record<string, unknown> | null,
  });
}
